import { agent } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson, fetchData } from "../FetchApi";

class AgentService extends CrudService {
  constructor() {
    super(agent);
  }


  async addUserLog(data) {
    return fetchDataJson(`${agent}/AddUserLog`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async getUserStatus(userEmail) {
    return fetchDataJson(`${agent}/GetUserStatus?userEmail=${encodeURIComponent(userEmail)}`, {
      method: "GET",
    });
  }

  async getActiveUsers(date, includeBreak = false) {
    return fetchDataJson(`${agent}/GetActiveUsers?date=${date}&includeBreak=${includeBreak}`, {
      method: "GET",
    });
  }

  async getAvailableUsers(date) {
    return fetchDataJson(`${agent}/GetAvailableUsers?date=${date}`, {
      method: "GET",
    });
  }

  async getCurrentCalls() {
    return fetchDataJson(`${agent}/GetCurrentCalls`, {
      method: "GET",
    });
  }

  async takeCall(data) {
    return fetchDataJson(`${agent}/TakeCall`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async acceptIncomingCall(data) {
    return fetchDataJson(`${agent}/AcceptIncomingCall`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async addCall(data) {
    if (data.id) return this.updateCall(data);

    return fetchDataJson(`${agent}/AddCall`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async manuallyAddCall(data) {
    return fetchDataJson(`${agent}/ManuallyAddCall`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateCall(data) {
    return fetchDataJson(`${agent}/UpdateCall`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async addCallLog(data) {
    return fetchDataJson(`${agent}/AddCallLog`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateCallLogEndTime(id) {
    return fetchDataJson(`${agent}/UpdateCallLogEndTime`, {
      method: "PUT",
      body: JSON.stringify(id)
    });
  }

  async updateCallLogTimeAnswered(data) {
    return fetchDataJson(`${agent}/UpdateCallLogTimeAnswered`, {
      method: "PUT",
      body: JSON.stringify(data)
    });
  }

  async getReportAndLogByCallID(id) {
    return fetchDataJson(`${agent}/GetReportAndLogByCallID/${id}`, {
      method: "GET",
    });
  }

  async getReportData(id) {
    return fetchDataJson(`${agent}/GetReportData/${id}`, {
      method: "GET",
    });
  }

  async getCall(id) {
    return fetchDataJson(`${agent}/GetCall/${id}`, {
      method: "GET",
    });
  }

  async getServiceReportData(id) {
    return fetchDataJson(`${agent}/GetServiceReportData/${id}`, {
      method: "GET",
    });
  }

  async saveServiceRequestReport(data) {
    return fetchDataJson(`${agent}/SaveServiceRequestReport`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async save911DispatchReport(data) {
    return fetchData(`${agent}/Save911DispatchReport`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async selectElevatorForCall(data) {
    return fetchDataJson(`${agent}/SelectElevatorForCall`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async notifyContactsThat911Called(call) {
    return fetchData(`${agent}/NotifyContactThat911Called`, {
      method: "POST",
      body: JSON.stringify(call),
    });
  }

  async sendCallSummaryReport(call) {
    return fetchData(`${agent}/SendCallSummaryReport`, {
      method: "POST",
      body: JSON.stringify(call),
    });
  }


  async getElevatorsByPhoneNumber(number) {
    return fetchDataJson(`${agent}/GetElevators?page=1&size=50&filter[PhoneNumber]=${number}*`);
  }

  async getElevator(id) {
    const listModel = await fetchDataJson(`${agent}/GetElevators?size=1&filter[Id]=${id}`);
    return listModel.model[0];
  }

  async getBuildingsByAddress(address, page = 1, size = 50, elevatorCompanyId = null) {
    const companyFilter = elevatorCompanyId ? `&filter[ElevatorCompanyId]=${encodeURIComponent(elevatorCompanyId)}` : "";

    return fetchDataJson(`${agent}/GetBuildings?page=${page}&size=${size}&filter[Address.Line1]=${encodeURIComponent(address || "")}*${companyFilter}`);
  }

  async getBuilding(id) {
    const listModel = await fetchDataJson(`${agent}/GetBuildings?size=1&filter[Id]=${id}`);
    return listModel.model[0];
  }

  async getPhoneNumber(id) {
    return fetchDataJson(`${agent}/GetPhoneNumber/${id}`, {
      method: "GET",
    });
  }

  async acceptDispatch(data) {
    return fetchDataJson(`${agent}/AcceptDispatch`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async getPendingDispatches(userEmail) {
    return fetchDataJson(`${agent}/PendingDispatches?userEmail=${userEmail}`, {
      method: "GET",
    });
  }

  //testing
  // async testTwillio(call) {
  //   return fetchData(`https://localhost:44348/TwilioCallCenterCallStatusCallback`, {
  //     method: "POST",
  //     body: JSON.stringify(call),
  //   });
  // }




}

export default new AgentService();
